import { Box, Button, ButtonGroup, Divider, IconButton } from "@mui/material";
import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ChangeTheme from "./changeTheme";
import { useNavigate } from "react-router-dom";
const Header = () => {

    const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // This navigates back to the previous page in the history stack.
  };
  return (
    <Box
      position="fixed"
      right="0px"
      top="0px"
      sx={{ width: "max-content", display: "flex" }}
      zIndex="100"
    >
        
      <ChangeTheme />
      <Divider orientation="vertical" />
      <IconButton
      onClick={handleGoBack}
        sx={{
          position: "relative",
          width: "40px",
          height: "40px",
          background: "orange",
          borderRadius: "0",
        }}
      >
        <ArrowBackIosIcon
          sx={{
            position: "absolute",
            ml: "5px",
          }}
        />
      </IconButton>
    </Box>
  );
};

export default Header;
